(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lwd-chapter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lwd-chapter]').forEach((root) => {
    const links = [...root.querySelectorAll('.lwd-rail a')]
    const targets = links.map((link) => document.querySelector(link.getAttribute('href'))).filter(Boolean)
    if (!targets.length) return
    const setActive = (id) => {
      links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`))
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) setActive(entry.target.id) })
    }, { rootMargin: '-20% 0px -70% 0px' })
    targets.forEach((target) => observer.observe(target))
  })

  } catch(e) { console.error(e); }
})();
})();
